/* 로그 페이지 관련 시작 */
export const AdminLogPath = [
  { label: "홈", href: "/admin" },
  { label: "로그" },
];
export const AdminLogTitle = AdminLogPath[AdminLogPath.length - 1].label;
/* 로그 페이지 관련 끝 */

/* 로그 관련 시작 */
export const LogTypes = [
  { key: "info", value: "정상" },
  { key: "error", value: "에러" },
];
export const LogType = (type: any) => {
  const object = LogTypes.find((item) => item.key === type.toString());
  return object?.value ?? type;
};

/* 로그 관련 끝 */
